import { createPivotTransformer, IDENTITY_PIVOT_MAPPING } from './create-pivot-transformer';
import { fpDivide, fpMultiply } from '../shared/utils';

const CELSIUS_MAPPING = IDENTITY_PIVOT_MAPPING;
const FAHRENHEIT_MAPPING = {
  toPivot: (v: number) => fpDivide(fpMultiply(v - 32, 5), 9),
  fromPivot: (v: number) => fpMultiply(v, 9 / 5) + 32,
};
const KELVIN_MAPPING = {
  toPivot: (v: number) => v - 273.15,
  fromPivot: (v: number) => v + 273.15,
};
const RANKINE_MAPPING = {
  toPivot: (v: number) => fpDivide(fpMultiply(v, 5), 9) - 273.15,
  fromPivot: (v: number) => fpMultiply(v + 273.15, 9 / 5),
};

/** Pivot = Celsius. Keys match catalog asciiSymbol values (lowercased). */
export const TEMPERATURE_PIVOT = {
  c: CELSIUS_MAPPING,
  f: FAHRENHEIT_MAPPING,
  k: KELVIN_MAPPING,
  r: RANKINE_MAPPING,
};

export const transformTemperature = createPivotTransformer(TEMPERATURE_PIVOT);
